import CommonUiModel from "../common/commonUiModel";

const releaseManagementConfig = {
    title: "Release Management",
    api: 'Revision',
    relations: ["Document"],
    hideBreadcrumbInGrid: true,
    showHistory: false,
    defaultSort: "",
    permissions: { add: false, edit: true, delete: false },
    module: 'ReleaseMgmt',
    navigateBack: ({ searchParams, data }) => {
        if (searchParams.get('from') === 'releasemgmt') {
            return -1;
        }
        return `/release/${data.EquipmentId}`;
    },
    columns: [
        { field: 'Revision', label: 'Revision', readOnly: true },
        { field: 'RevisionStatusId', label: null, gridLabel: 'Status', lookup: 'RevisionStatus', type: 'select', dataIndex: 'RevisionStatus' },
        { field: 'RevisionStatusId', label: 'Status', gridLabel: null, lookup: 'RevisionType', type: 'select', dataIndex: 'RevisionStatus' },
        { field: 'Version', label: 'Version' },
        { field: 'StagedRevision', label: 'Staged Revision', readOnly: true },
        { field: 'PlmReference', label: 'PLM ECN#' },
        { field: 'Notes', label: 'Notes', multiline: true }
    ]
};
const ReleaseManagement = new CommonUiModel(releaseManagementConfig);
export { releaseManagementConfig };
export default ReleaseManagement;